import * as React from 'react';
import Box from '@mui/material/Box';
import ViewAssignReferralReq from './ViewAssignReferralReq';

const AssignReferralReqHome = () => {

    return (
        <Box sx={{ width: '100%' }}>
            <ViewAssignReferralReq />
        </Box>
    );
}

export default AssignReferralReqHome